import type { PaginationParams } from "Care/types/api";

export const PAGE_SIZE = 50;
export const careApiURL = "/care/api/v0";

/** @see https://web.developer.smartlook.com/reference/smartlookinit */
export const SMARTLOOK_PROJECT_KEY = "090b6bee7e9e3afd4d26ca39269321b98448d86e";

export const DEFAULT_SEARCH_RADIUS = 25;
export const DEFAULT_PRICING_RADIUS = 25;

/** Cache data for this long via Rails Cache (Redis) */
export const CACHE_DURATION_SECONDS = 24 * 60 * 60;

export const paginationDefaults: PaginationParams = {
  limit: PAGE_SIZE,
  offset: 0,
};
